import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, Icon } from 'antd';
import { isPurchaseEnabled } from '../../../utils/featureGates';

const { ItemGroup } = Menu;

const NoPlanMenu = ({ selectedKey }) => (
  <Menu mode="inline" inlineIndent={8} selectedKeys={[selectedKey]} className="sider-menu">
    <Menu.Item key="/dashboard">
      <Link to="/dashboard">
        <Icon type="dashboard" aria-hidden />
        <span>Dashboard</span>
      </Link>
    </Menu.Item>

    <Menu.Item key="/organization/plans">
      <Link to="/organization/plans">
        <Icon type="schedule" aria-hidden />
        <span>Plans</span>
      </Link>
    </Menu.Item>

    <ItemGroup key="organisation_setup" title="Organisation setup">
      <Menu.Item key="/organization">
        <Link to="/organization">
          <Icon type="setting" aria-hidden />
          <span>Organisation Settings</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="/organization/contacts">
        <Link to="/organization/contacts">
          <Icon type="contacts" aria-hidden />
          <span>Internal Contacts</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="/organization/strategic-areas">
        <Link to="/organization/strategic-areas">
          <Icon type="environment" aria-hidden />
          <span>Strategic Areas</span>
        </Link>
      </Menu.Item>
    </ItemGroup>

    {isPurchaseEnabled() ? (
      <Menu.Item key="/purchase">
        <Link to="/purchase">
          <Icon type="shopping" aria-hidden />
          <span>Buy subscriptions</span>
        </Link>
      </Menu.Item>
    ) : null}
  </Menu>
);

export default NoPlanMenu;
